import React, {ReactNode, useMemo, useReducer} from 'react';
import {StoreContext} from 'store/context';
import {initialState as defaultInitialState} from 'store/defaultState';
import {rootReducer as defaultRootReducer} from './rootReducer';

type StoreProviderProps = {
  children: ReactNode;
  rootReducer?: RootReducer;
  initialState?: AppState;
};

export const StoreProvider: React.FC<StoreProviderProps> = ({
  children,
  initialState = defaultInitialState,
  rootReducer = defaultRootReducer,
}: StoreProviderProps) => {
  const [state, dispatch] = useReducer(rootReducer, initialState);
  const value = useMemo(() => ({state, dispatch}), [state]);
  return <StoreContext.Provider value={value}>{children}</StoreContext.Provider>;
};
